import React__default from 'react';
import { DepartmentIcon } from '@deal/components';
import { useApplicationContext, Application } from '../../../containers/ApplicationContext/index.js';
import MessageBubble from '../../MessageBubble/index.js';
import MessageBubbleText from '../../MessageBubbleText/index.js';
import { BusinessRichCardEvents } from '../../../containers/RichCardEventEmitter/BusinessEventData/index.js';
import { ConsumerRichCardEvents } from '../../../containers/RichCardEventEmitter/ConsumerEventData/index.js';
import { useRichCardEventEmitter } from '../../../containers/RichCardEventEmitter/index.js';
import { newSystemCuratedItemsRichCard, newExpertCuratedItemsRichCard, updatedExpertCuratedItemsRichCard } from '../../../services/richCardFactory.js';
import HeroWithImage from '../components/HeroWithImage/index.js';
import CallToAction from '../components/CallToAction/index.js';
import { ProductCurationActivationComponent } from './ProductCurationActivation.generated.js';
import CurationIcon from './curation.svg.js';
import styles from './styles.css.js';

var ProductCurationMessage = function ProductCurationMessage(_a) {
  var message = _a.message,
      myself = _a.myself;
  var systemCurationRichCard = newSystemCuratedItemsRichCard(message);
  var newCurationRichCard = newExpertCuratedItemsRichCard(message);
  var updatedCurationRichCard = updatedExpertCuratedItemsRichCard(message);
  var activationId = (newCurationRichCard === null || newCurationRichCard === void 0 ? void 0 : newCurationRichCard.expertCuratedItemActivationId) || (updatedCurationRichCard === null || updatedCurationRichCard === void 0 ? void 0 : updatedCurationRichCard.expertCuratedItemActivationId) || (systemCurationRichCard === null || systemCurationRichCard === void 0 ? void 0 : systemCurationRichCard.expertCuratedItemActivationId);
  var curatedByExpert = newCurationRichCard != undefined || updatedCurationRichCard != undefined;
  var richCardEventEmitter = useRichCardEventEmitter();
  var application = useApplicationContext().application;

  if (!activationId) {
    return null;
  }

  return React__default.createElement(ProductCurationActivationComponent, {
    variables: {
      activationId: activationId
    }
  }, function (_a) {
    var data = _a.data,
        loading = _a.loading;

    if (data && data.expertCuratedItemActivation) {
      var expert = data.expertCuratedItemActivation.activatedBy;
      var consumer = data.expertCuratedItemActivation.lead.consumer;
      var itemCount = data.expertCuratedItemActivation.activated.length;
      var category = data.expertCuratedItemActivation.lead && data.expertCuratedItemActivation.lead.category;
      var banner = category && category.contentAssets.bannerImages && category.contentAssets.bannerImages[0];
      var leadId_1 = data.expertCuratedItemActivation.lead.id;
      return React__default.createElement(MessageBubble, {
        message: message
      }, React__default.createElement(HeroWithImage, {
        imageUrl: banner === null || banner === void 0 ? void 0 : banner.imageUrl,
        heroLabel: React__default.createElement(React__default.Fragment, null, category && category.department && React__default.createElement(React__default.Fragment, null, React__default.createElement(DepartmentIcon, {
          className: styles.categoryIcon,
          departmentSlug: category.department.slug
        }), React__default.createElement("div", {
          className: styles.break
        })), expert.shortName + "'s picks " + (myself && "for " + consumer.firstName))
      }), curatedByExpert && React__default.createElement("div", {
        className: styles.caption
      }, React__default.createElement(CurationIcon, {
        className: styles.curationIcon
      }), itemCount === 1 ? 'Hand' : itemCount + " hand", " picked items for you."), application === Application.CONSUMER ? React__default.createElement(CallToAction, {
        onClick: function onClick() {
          return richCardEventEmitter === null || richCardEventEmitter === void 0 ? void 0 : richCardEventEmitter.emitEvent({
            type: ConsumerRichCardEvents.VIEW_PRODUCT_CURATION,
            leadId: leadId_1
          });
        }
      }, curatedByExpert ? 'View Your Options' : 'View Your Recommendations') : application === Application.BUSINESS ? React__default.createElement(CallToAction, {
        onClick: function onClick() {
          return richCardEventEmitter === null || richCardEventEmitter === void 0 ? void 0 : richCardEventEmitter.emitEvent({
            type: BusinessRichCardEvents.EDIT_PRODUCT_CURATION,
            leadId: leadId_1
          });
        }
      }, "Edit Your Recommendations") : React__default.createElement(CallToAction, null, "Edit Your Recommendations"));
    } else if (loading) {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Loading...");
    } else {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Error loading messages!");
    }
  });
};

ProductCurationMessage.handlesMessage = function (message) {
  return (newExpertCuratedItemsRichCard(message) || updatedExpertCuratedItemsRichCard(message) || newSystemCuratedItemsRichCard(message)) !== undefined;
};

export default ProductCurationMessage;
//# sourceMappingURL=index.js.map
